import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Button from 'portal-modules/common/components/Button'
import { TaxDetails } from 'portal-modules/common/components'
import { RpModal } from 'portal-modules/common/components/modals'
import { Spinner } from 'portal-modules/common/components/loaders'
import getDateForLocale from 'portal-modules/common/utils/get-date-for-locale'

const StyledSection = styled('section')`
  display: flex;
  justify-content: space-between;
  padding: ${({ hasTaxes }) => (hasTaxes ? '4px 0' : '8px 0')};
`

const StyledButton = styled(Button)`
  min-width: 100%;
`

const StyledTaxDisclaimer = styled('span')`
  color: ${({ theme }) => theme.gray.medium};
  display: flex;
  font-size: 12px;
  font-style: italic;
`

const StyledTaxAmountTotal = styled('section')`
  display: flex;
  justify-content: space-between;
  color: #959595b8;
  font-size: 12px;
  margin-top: 12px;
`

const StyledLoaderDiv = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
`

const BulkTransactionDetailsModal = ({
  transactionDetails,
  onClose,
  currencyCode,
  changeUnitTo,
  ...props
}) => {
  const {
    amount,
    total_amount,
    date,
    title,
    fee_amount,
    created_by_name,
    unit_number,
  } = transactionDetails

  const [loader, setLoader] = useState(false)

  useEffect(() => {
    setLoader(true)
    setTimeout(() => {
      setLoader(false)
    }, 300)
  }, [])

  return (
    <RpModal
      {...props}
      title={title}
      footerContent={
        <StyledButton appearance='primary' onClick={onClose}>
          {__('Close')}
        </StyledButton>
      }
    >
      {loader ? (
        <StyledLoaderDiv>
          <Spinner />
        </StyledLoaderDiv>
      ) : (
        <div>
          {unit_number && (
            <StyledSection>
              <span>
                {__('{%s,0}', [changeUnitTo ? changeUnitTo : 'Unit'])}
              </span>
              <span>{__('{%s,0}', [unit_number])}</span>
            </StyledSection>
          )}
          {'May' == i18nUtils.datetime(date, 'MMM') ? (
            <StyledSection>
              <span>{__('Payment Date')}</span>
              <span>{getDateForLocale(date)}</span>
            </StyledSection>
          ) : (
            <StyledSection>
              <span>{__('Payment Date')}</span>
              <span>{getDateForLocale(date, 'MMM. D, YYYY')}</span>
            </StyledSection>
          )}
          <StyledSection>
            <span>{__('Time of Payment')}</span>
            <span>{i18nUtils.datetime(date, 'TIME_SHORT')}</span>
          </StyledSection>
          {created_by_name && (
            <StyledSection>
              <span>{__('Submitted By')}</span>
              <span>{__('{%s,0}', [created_by_name])}</span>
            </StyledSection>
          )}
          {amount && (
            <StyledSection>
              <span>{__('Payment Amount')}</span>
              <span>{i18nUtils.currency(amount)}</span>
            </StyledSection>
          )}
          {fee_amount > 0 && (
            <StyledSection>
              <span>
                {'CAD' === currencyCode
                  ? __('Service Fee')
                  : __('Convenience Fee')}
              </span>
              <span>{i18nUtils.currency(fee_amount)}</span>
            </StyledSection>
          )}
          {total_amount && total_amount > amount && (
            <StyledSection>
              <span>{__('Payment Total')}</span>
              <span>{i18nUtils.currency(total_amount)}</span>
            </StyledSection>
          )}
        </div>
      )}
    </RpModal>
  )
}

BulkTransactionDetailsModal.propTypes = {
  transactionDetails: PropTypes.object,
  onClose: PropTypes.func,
  currencyCode: PropTypes.string,
  changeUnitTo: PropTypes.string,
}

export default connect(({ settings: { payments } }) => {
  return {
    currencyCode: (payments && payments.currency_code) || 'USD',
  }
})(BulkTransactionDetailsModal)
